import React, { memo } from "react";
import {
  OverlayTrigger,
  Tooltip
} from "react-bootstrap";
import "./index.css";

const MenuCommandsItem = ({ getCount, icon, id, onClick, selected, title }) => {
  return (
    <li>
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip>
            {title}
            {getCount ? ` (${getCount()})` : null}
          </Tooltip>
        }
      >
        <button
          className={`mcm-cm-icon ${selected && selected() ? "active" : ""} ${id}`}
          type="button"
          onClick={onClick}>
          {icon}
          {getCount && getCount() > 0 ? <div className="mcm-cm-icon-count">{getCount()}</div> : null}
        </button>
      </OverlayTrigger>
    </li>
  );
};

export default memo(MenuCommandsItem);
